import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import i18n from './locales'

const app = createApp(App)

app.use(router)
app.use(createPinia())
app.use(ElementPlus)
app.use(i18n)

app.mount('#app')